import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  root: css`
    background-color: ${cssTheme.default.day.controlMinor} !important;
  `,
}
